(() => {
  const progress = document.querySelector('[data-br-brain-energy-progress]');
  if (!progress) return;
  const update = () => {
    const root = document.documentElement;
    const distance = root.scrollHeight - root.clientHeight;
    progress.style.width = `${distance > 0 ? Math.min(100, (root.scrollTop / distance) * 100) : 0}%`;
  };
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
})();
